import { FormControl, FormBuilder, Validators, FormGroup } from '@angular/forms';
import { NoteForm } from '../forms/note-form';
import { TabProfile } from 'src/app/services/API.service';
import { TableForm } from '../forms/table-form';
import { timeStamp } from 'console';

export class TabForm {
    id = new FormControl();
    UserID = new FormControl();
    Title = new FormControl();
    RecordKey = new FormControl();
    ExclusionList = new FormControl();
    Type = new FormControl();
    Created = new FormControl();
    Modified = new FormControl();
    Table: FormGroup;
    Note: FormGroup;

    constructor(tab: TabProfile, private fb: FormBuilder) {

        this.id.setValue(tab.id);
        this.UserID.setValue(tab.UserID);
        this.Title.setValue(tab.Title);
        this.RecordKey.setValue(tab.RecordKey);
        this.ExclusionList.setValue(tab.ExclusionList);
        this.Type.setValue(tab.Type);
        this.Created.setValue(tab.createdAt);
        this.Modified.setValue(tab.updatedAt);
        this.Table = this.fb.group(new TableForm(tab.Table, this.fb));
        this.Note = this.fb.group(new NoteForm(tab.Note, this.fb));

        this.UserID.setValidators([Validators.required]);
        this.Title.setValidators([Validators.required]);
        this.RecordKey.setValidators([Validators.required]);
        this.Type.setValidators([Validators.required]);
    }
}